import { ComponentProps } from 'react';
import { Modal } from '@hopskipdrive/react-components';
import { Paper } from '@mui/material';
import { Button } from '@rideiq/shared/components/Button';
import { colorTokens } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const SecondaryButtonStyled = styled(Button)`
  flex-shrink: 0;
  margin-top: 3px;
  margin-left: 8px;
`;

export const ModalActionsStyled = styled(Modal.Actions)`
  justify-content: space-between;
`;

export const MFAModalPaper = ({ children, ...props }: ComponentProps<typeof Paper>) => (
  <Paper {...props} aria-modal="true">
    {children}
  </Paper>
);

export const CloseButton = styled('button')`
  padding: 0;
  border: 0;
  background: transparent;
  display: inline-flex;
  margin-left: auto;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  svg {
    color: ${colorTokens.text.medium};
  }

  &:hover {
    background: transparent;
    svg {
      color: ${colorTokens.text.hover};
    }
  }

  &:focus-visible {
    outline: 2px solid ${colorTokens.text.hover};
    outline-offset: 2px;
  }
`;

export const FormMessage = styled('p')`
  color: ${colorTokens.text.medium};
  margin-left: 16px;
`;

export const MethodNavigation = styled.button`
  padding: 0;
  border: 0;
  background: transparent;
  color: ${colorTokens.text.active};
  font: inherit;
  text-decoration: underline;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${colorTokens.text.hover};
    outline-offset: 2px;
  }
  &:disabled {
    cursor: wait;
    opacity: 0.6;
  }
`;
